import { Injectable, ElementRef } from '@angular/core';
import * as html2canvas from 'html2canvas';
import { MatDialog } from '@angular/material/dialog';
import { SoporteComponent } from 'app/common/soporte/components/soporte.component';

@Injectable({
  providedIn: 'root'
})
export class CapturaPantallaService {

  constructor(private _matDialog: MatDialog) { }

  realizarCapturaDePantalla(screen: ElementRef){
    html2canvas(screen.nativeElement, { 
      useCORS : true, 
      allowTaint : true,
      foreignObjectRendering: true
    }).then(canvas => {
        this._matDialog.open(SoporteComponent, 
        {
            panelClass: 'soporte',
            data: {
                captura: canvas.toDataURL('image/png')
            }
        });
    });
  }
}
